import type { FolderPermissions } from '../services/folder-api';

export const NO_FOLDER_PERMISSIONS: FolderPermissions = {
  Folder_Read: false,
  Folder_Update: false,
  Folder_Delete: false,
  Folder_Trash: false,
  Folder_Restore: false,
  Folder_Move: false,
  Folder_AddDoc: false,
  Folder_RemoveDoc: false,
  Folder_CreateSubfolder: false,
  Folder_Users_Read: false,
  Folder_Users_Manage: false,
};

export const OWNER_FOLDER_PERMISSIONS: FolderPermissions = {
  Folder_Read: true,
  Folder_Update: true,
  Folder_Delete: true,
  Folder_Trash: true,
  Folder_Restore: true,
  Folder_Move: true,
  Folder_AddDoc: true,
  Folder_RemoveDoc: true,
  Folder_CreateSubfolder: true,
  Folder_Users_Read: true,
  Folder_Users_Manage: true,
};
